<!-- start page title -->
<section class="sub-page-heading-section wow animate__fadeIn bg-light-gray padding-25px-tb page-title-small">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-12 col-xl-8 col-lg-6">
                <h1 class="alt-font text-extra-dark-gray font-weight-500 no-margin-bottom text-center text-lg-start">Checkout</h1>
            </div>
            <div class="col-12 col-xl-4 col-lg-6 breadcrumb justify-content-center justify-content-lg-end text-small alt-font md-margin-10px-top">
                <ul class="xs-text-center">
                    <li><a [routerLink]="['/']">Home</a></li>
                    <li><a [routerLink]="['/shopping-cart']">Shopping Cart</a></li>
                    <li>Checkout</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- end page title -->
<!-- start section -->
<section class="wow animate__fadeIn">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-12 mb-3" id="accordion1" *ngIf="!isLoggedIn$">
                <!--start tab content -->
                <div class="d-sm-flex justify-content-center align-items-center padding-10px-bottom text-center">
                    <i class="feather icon-feather-user text-fast-blue margin-10px-right"></i>
                    <span class="text-extra-dark-gray alt-font">Returning customer?&nbsp;</span><a class="accordion-toggle text-extra-dark-gray text-decoration-underline" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#collapseOne"><span class="alt-font">Click here to login</span></a>
                </div>
                <div id="collapseOne" class="collapse text-center" data-bs-parent="#accordion1">
                    <form [formGroup]="loginForm" id="loginForm" class="w-40 mx-auto margin-1-half-rem-tb text-start lg-w-50 sm-w-100">
                        <p>If you have shopped with us before, please enter your details below. If you are a new customer, please proceed to the billing section.</p>
                        <div class="row margin-10px-bottom text-start">
                            <div class="col-6">
                                <label class="margin-15px-bottom">Username or email <span class="text-radical-red">*</span></label>
                                <input class="small-input" type="email" name="email" placeholder="Enter your email" formControlName="username">
                            </div>
                            <div class="col-6">
                                <label class="margin-15px-bottom">Password <span class="text-radical-red">*</span></label>
                                <input class="small-input" type="password" name="password" placeholder="Enter your password" formControlName="password">
                            </div>
                        </div>
                        <button (click)="validateLogin()" class="btn btn-medium btn-dark-gray d-block margin-20px-bottom">Login</button>
                    </form>
                </div>
            </div>
            <div class="col-12 col-lg-7 col-md-6 padding-70px-right lg-padding-40px-right md-padding-15px-right" *ngIf="!isLoggedIn$">
                <span class="alt-font text-large text-extra-dark-gray margin-40px-bottom d-inline-block font-weight-500">Billing details</span>
                <form [formGroup]="regForm" id="regForm">
                    <div class="row">
                        <div class="col-md-6 margin-10px-bottom">
                            <label class="margin-15px-bottom">First name <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="text" formControlName="firstname">
                        </div>
                        <div class="col-md-6 margin-10px-bottom">
                            <label class="margin-15px-bottom">Last name <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="text" formControlName="lastname" required>
                        </div>    
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Company name (optional)</label>
                            <input class="small-input" formControlName="company_name" type="text">
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Street address <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="text" formControlName="address_1" placeholder="House number and street name">
                            <input class="small-input" type="text" formControlName="address_2" placeholder="Apartment,suite,unit etc. (optional)">
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Suburb/State/Postal Code<span class="text-radical-red">*</span></label>
                            <ng-select formControlName="address" [minTermLength]="postalCodeMinLengthTerm" [loading]="postalCodeLoading"
                                [typeahead]="postalCodeInput$" >
                                <ng-option *ngFor="let item of postalCodes$ | async" [value]="item">
                                    {{ item.suburb + ', ' + item.state + ', ' + item.postcode }}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Phone <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="text" formControlName="contact_no" required>
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Email address <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="text" formControlName="email" required>
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Password <span class="text-radical-red">*</span></label>
                            <input class="small-input" type="password" formControlName="password" required>
                        </div>
                        <div class="col-12 margin-10px-bottom">
                            <label class="margin-15px-bottom">Payment Details<span class="text-radical-red">*</span></label>
                            <div id="stripe-card"><!--Stripe.js injects the Payment Element--></div>
                        </div>
                        <!-- start tab content -->    
                        <!-- <div class="col-md-12 position-relative checkout-accordion">
                            <p class="title mb-2 d-flex">
                                <label class="margin-5px-bottom">
                                    <input class="d-inline w-auto mb-0 me-2 mt-1" type="checkbox" name="account">
                                    <span class=" d-inline-block text-decoration-none">Create an account?</span> 
                                    <a class="accordion-toggle text-black" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#collapseThree"></a>
                                </label>
                            </p>
                            <div id="collapseThree" class="collapse">
                                <div class="padding-25px-left margin-2-half-rem-bottom md-no-padding-left">
                                    <label class="margin-15px-bottom">Account username <span class="text-radical-red">*</span></label>
                                    <input class="small-input" type="text" placeholder="Enter username" required>
                                    <label class="margin-15px-bottom">Create account password <span class="text-radical-red">*</span></label>
                                    <input class="small-input" type="password" placeholder="Enter password" required>      
                                </div>
                            </div>
                        </div> -->
                        <!-- end tab content -->
                        <div class="col-12">
                            <label class="margin-15px-bottom">Reference No (optional)</label>
                            <input class="small-input" type="text" formControlName="reference_no">
                        </div>
                       
                    </div>
                </form>
            </div>
            <div class="col-12 col-lg-5 col-md-6">
                <div class="bg-light-gray padding-45px-all lg-padding-30px-all sm-padding-20px-all">
                    <span class="alt-font text-large text-extra-dark-gray margin-25px-bottom d-inline-block font-weight-500">Your order</span>
                    <table class="total-price-table checkout-total-price-table">
                        <thead class="border-bottom border-color-medium-gray text-extra-dark-gray">
                            <tr>
                                <th class="product-name font-weight-500 w-60">Product</th>
                                <th class="product-name font-weight-500 w-60"></th>
                                <th class="product-total pe-0 font-weight-500">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let product of cartService.cart.orderList; let i = index">
                                <td>{{product.name}}</td>
                                <td>{{product.qty}} x {{product.unit_price|currency}} </td>
                                <td>${{product.total()}}</td>
                            </tr>
    
                            <tr class="total-amount">
                                <th class="font-weight-500 text-extra-dark-gray">Total</th>
                                <td colspan="2">
                                    <h6 class="d-block font-weight-500 mb-0 text-extra-dark-gray">${{cartService.cart.total}}</h6>
                                    <span class="text-small"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            
                
                    <button type="submit" *ngIf="!loading" (click)="validatePlaceOrder()" class="btn btn-fancy btn-dark-gray btn-extra-large w-100 margin-15px-top">Place order</button>
                    <button type="button"  *ngIf="loading" class="btn btn-fancy btn-dark-gray btn-extra-large w-100 margin-15px-top">Placing your order...</button>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end section -->